import { render } from "./StaffGroup.vue?vue&type=template&id=9fe9f112"
import script from "./StaffGroup.vue?vue&type=script&lang=js"
export * from "./StaffGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__